import { Box, FormControl, FormLabel, TextField } from "@mui/material";
import { useFormikContext } from "formik";
import { PlanFormValues } from "../PlanFormValues";

export const PublicTransportSettingsFields = () => {
  const { values, errors, touched, handleChange } =
    useFormikContext<PlanFormValues>();

  return (
    <>
      <Box>
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend">Name</FormLabel>
          <TextField
            name="name"
            value={values.name}
            onChange={handleChange}
            required
            fullWidth
            size="small"
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && (errors.name as string)}
          />
        </FormControl>
      </Box>
    </>
  );
};
